import React from "react";
import styles from "./styles.module.scss";

export default function SidebarDivider({ children }) {
  return <div className={styles.divider}>{children}</div>;
}
